'use strict';

import { Entity } from '../Entity';

export class UserSavedReport extends Entity {
  protected id;

  protected user;

  protected name;

  protected content;

  protected include;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.id = data.id;

    this.user = data.user;

    this.name = data.name;

    this.content = data.content;

    this.include = data.include;
  }

  public getId() {
    return this.id;
  }

  public setId(id) {
    this.id = id;

    return this;
  }

  public getUser() {
    return this.user;
  }

  public setUser(user) {
    this.user = user;

    return this;
  }

  public getName() {
    return this.name;
  }

  public setName(name) {
    this.name = name;

    return this;
  }

  public getContent() {
    return this.content;
  }

  public setContent(content) {
    this.content = content;

    return this;
  }

  public getInclude() {
    return this.include;
  }

  public setInclude(include) {
    this.include = include;

    return this;
  }
}
